var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicatorAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(3793 930)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 24,
    height: 24,
    transform: "translate(-3793 -930)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(87.998 3.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "click-icon",
    d: "M14.707,15.139a1.34,1.34,0,1,1-1.9,1.893L9.685,13.894A1.34,1.34,0,1,1,11.578,12Z",
    transform: "translate(-3882.635 -937.019)",
    fill: "#2a7dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "click-icon-2",
    "data-name": "click-icon",
    d: "M16.05,5.781a1.328,1.328,0,0,1-.4.944h0a1.338,1.338,0,0,1-2.28-.948V1.34A1.343,1.343,0,0,1,14.71,0a1.32,1.32,0,0,1,.944.4,1.34,1.34,0,0,1,.4.948ZM5.792,14.62a1.316,1.316,0,0,1,.936.4A1.34,1.34,0,0,1,5.784,17.3H1.35a1.328,1.328,0,0,1-.944-.4A1.343,1.343,0,0,1,1.35,14.62Z",
    transform: "translate(-3877.032 -930)",
    fill: "#2a7dff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorAsset);
export default __webpack_public_path__ + "static/media/indicator-asset.7db0c9db5743fd4ec8729a8ce9611bae.svg";
export { ForwardRef as ReactComponent };